export default __webpack_public_path__ + "86be69bc762df264227b8bd6b31fed3b.svg";